
import { createTheme } from '@mui/material/styles';


 
const theme = createTheme ({
    breakpoints: {
      values: {
        xs: 0,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1100,
      },
    }, 

    palette: {
      primary: {
        // light: will be calculated from palette.primary.main,
        main: '#0d3880',
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      },
      secondary: {
        // light: will be calculated from palette.primary.main,
        main: '#e3064f',
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      },
    },

    components: {
      MuiAutocomplete: {
        styleOverrides: {
          root: {
        
          },
          input: {
            padding: '4px 4px 4px 0px' 
          },
          listbox: {
            
            fontSize: ".85rem",
          },
        },
      },

      MuiAlert: {
        styleOverrides: {
          root: {
        backgroundColor: '#e3064f',
        color:  'white'
          } 
        },
      },

      MuiTooltip:
      {
        styleOverrides: {
        tooltip: {
            fontSize: ".8rem",
            backgroundColor: '#0d3880',

 
          
        },
        arrow:{
          color: '#0d3880',
        },
        popperArrow: {
        
          
        
        },

        }
      },
   

 
      MuiFormHelperText: 
      {
        styleOverrides: {
          root: { 
            
            input: { 
              
            },  
            "&.Mui-error": {
              color: "#e3064f"
            }
 

        },
      } 
      },


      MuiInput: 
      {
        styleOverrides: {
          root: { 
            
            input: {

            padding: '4px 4px 4px 0px' 
              
            },   
 

        },
      } 
      },

      MuiSelect:
      {
        styleOverrides: { 
            select: {
              padding: '4px 4px 4px 0px' 
            },  
      } 
      },
     

      MuiInputBase: 
      {
        styleOverrides: {
          root: { 
            
            input: {
              padding: '4px 4px 4px 0px' 
            }, 

            inputProps:
            { 
              
            }, 

            fontSize: ".9rem" 

        },
      } 
      },

        
  
    MuiFormLabel:
    {
      styleOverrides: {
      root: {
        "&.Mui-disabled": {
          color: "#0d3880"
        },
        "&.Mui-error": {
          color: "#0d3880"
        }
      }
    }
    },
 
      
 

      MuiCheckbox: {
        styleOverrides: {
        colorSecondary: {
          color: "grey",
          "&:hover": {
            color: "#00b5e5"
          },
          "&$checked": {
            color: "#00b5e5",
            "&:hover": {
              color: "lightblue"
            },
            "&.Mui-focusVisible": {
              color: "red"
            }
          },
          "&.Mui-focusVisible": {
            color: "white"
          } 
        }
      }
      },


      MuiFormControlLabel :{
        styleOverrides: {
        label: {fontSize: "small", color:'#007bff', fontWeight:"bold"},
        }
      },

      MuiDivider:{
        styleOverrides: {
        root: {backgroundColor: 'red', color:'red' , width:'80%'}
        }
      },

      MuiFormControl:{
        styleOverrides: {
        root: {width: '100%'},
        marginNormal: {marginTop: '0'}
        }
      },

      MuiInputLabel:{
        styleOverrides: {
        shrink: {fontSize: "large", color:'#0d3880', fontWeight:"bold",whiteSpace:'nowrap',  }
        }
      },

 
    
     
 

      MuiAppBar:{
        styleOverrides: {
        colorPrimary:{  backgroundColor: '#007bff'}
        }

      },

  

  
      MuiLink:
      {
        styleOverrides: {
        underlineHover:
        {
          '&:hover': {
            
            textDecoration: 'none'
          },
          
        }
      }
      },
      
   
  
      MuiButton:{
        styleOverrides: {
        root: {
          '&:focus': {
            
            outline: 'none'
          } 
        }
        },
      
      },
   
   
               
    },
  
   
}
  
   );


  export default theme;